module.exports = __webpack_public_path__ + "img/csm_teaser-kinderrechte_ac1bb199c0.jpg.pagespeed.ce.fjyMrPmKKE.7e3c8cac.jpg";